import { Injectable } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { AppDialogService } from 'app/shared/dialogs/dynamic-dialog.service';
import { ProjectUnderlagComponent } from './project-underlag.component';

@Injectable({ providedIn: 'root' })
export class ProjectUnderlagDialogService {
  constructor(private appDialogService: AppDialogService) {}

  public openProjectUnderlag(data): DynamicDialogRef {
    this.appDialogService.layout = 'wide';
    this.appDialogService.data = data;
    return this.appDialogService.openComponent(ProjectUnderlagComponent);
  }
}
